import SplashScreen from '@/components/SplashScreen';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';
import { router } from 'expo-router';
import { useEffect, useRef, useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

export default function IndexScreen() {
  const { session, loading: authLoading } = useAuth();
  const [splashFinished, setSplashFinished] = useState(false);
  const [destination, setDestination] = useState<string | null>(null);
  const [isNavigating, setIsNavigating] = useState(false);
  const hasChecked = useRef(false);

  // ✅ Sur web, réinitialiser hasChecked quand on revient sur la page
  useEffect(() => {
    if (Platform.OS === 'web') {
      const currentPath = window.location.pathname;
      // Si on est sur subscription-success, ne pas interférer
      if (currentPath.includes('subscription-success')) {
        console.log('=== INDEX: On subscription-success page, skipping redirect ===');
        hasChecked.current = true;
        return;
      }
      // ✅ FIX: Réinitialiser pour que l'auth se relance quand on revient sur /
      if (currentPath === '/' || currentPath === '') {
        hasChecked.current = false;
      }
    }
  }, []);

  // Vérifier l'auth PENDANT le splash
  useEffect(() => {
    if (authLoading || hasChecked.current) return;

    // ✅ Sur web, vérifier si on est sur une page spécifique
    if (Platform.OS === 'web') {
      const currentPath = window.location.pathname;
      if (currentPath !== '/' && currentPath !== '') {
        console.log('=== INDEX: Not on root path, skipping ===', currentPath);
        hasChecked.current = true;
        return;
      }
    }

    const checkAuth = async () => {
      hasChecked.current = true;
      console.log('=== INDEX: Checking auth during splash ===');

      if (!session) {
        setDestination('/login');
        return;
      }

      const { data: profile } = await supabase
        .from('profiles')
        .select('onboarding_completed')
        .eq('id', session.user.id)
        .maybeSingle();

      if (profile?.onboarding_completed) {
        setDestination('/(tabs)');
      } else {
        setDestination('/onboarding');
      }
    };

    checkAuth();
  }, [session, authLoading]);

  // Rediriger quand splash terminé ET destination connue
  useEffect(() => {
    if (splashFinished && destination && !isNavigating) {
      setIsNavigating(true);
      // Petit délai pour laisser le fade-out se terminer
      setTimeout(() => {
        router.replace(destination as any);
      }, 100);
    }
  }, [splashFinished, destination, isNavigating]);

  const handleSplashFinish = () => {
    setSplashFinished(true);
  };

  // ✅ Sur web, si on n'est pas sur la racine, ne rien afficher
  if (Platform.OS === 'web') {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
    if (currentPath !== '/' && currentPath !== '') {
      return null;
    }
  }

  // Si on navigue, garder le fond indigo
  if (isNavigating) {
    return <View style={styles.transitionBackground} />;
  }

  // Afficher le splash
  return <SplashScreen onFinish={handleSplashFinish} />;
}

const styles = StyleSheet.create({
  transitionBackground: {
    flex: 1,
    backgroundColor: '#6366F1',
  },
});